import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M8.049,3.78459082 L11.9014677,4.79136297 L7.8522598,5.89438837 L4,4.79136297 L7.951,3.78459082 C7.98288889,3.77603527 8.01672222,3.77603527 8.049,3.78459082 Z M8.12166595,6.43935385 L12.6666667,5.13325749 L12.6666667,10.5839242 L12.536,10.7674797 L8.12166595,12.2218258 L8.12166595,6.43935385 Z M3.33333333,10.5839242 L3.33333333,5.18770194 L7.49752755,6.40986103 L7.49752755,12.2192797 L3.464,10.7674797 L3.33333333,10.5839242 Z"/>
  </svg>
);
